<app-auth-navbar></app-auth-navbar>
<main class="rtl">
    <div class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
        <div class="absolute top-0 w-full h-full bg-center bg-cover">
            <span class="bg-primary w-full h-full absolute" id="blackOverlay"></span>
        </div>
        <div class="container relative mx-auto">
            <div class="items-center flex flex-wrap">
                <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                    <div class="">
                        <h1 class="text-white font-semibold text-5xl leading-normal">
                            استاد ویزیت، سامانه ویزیت و مشاوره آنلاین پزشکی
                        </h1>
                        <div class="relative flex w-full flex-wrap items-stretch mt-12"><span
                                class="z-10 h-full leading-snug font-normal text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"><i
                                    class="fa fa-search"></i></span><input type="text"
                                placeholder=" نام پزشک، نام بیماری، تخصص ... "
                                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded shadow  w-full pl-10">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="pt-32 py-16 main-bg">
        <div class="container mx-auto px-4">
            <div class="flex flex-wrap">
                <div class="w-full lg:w-6/12 xl:w-8/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 shadow-lg">
                        <div class="relative md:flex break-words">
                            <img alt="..." src="assets/img/team-1-800x800.jpg" class="shadow-lg rounded-full max-w-120-px my-4" />
                            <div class="p-4">
                                <h5 class="text-xl font-bold"> دکتر سمیرا زارع فر </h5>
                                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                    متخصص بیماری های عفونی
                                </p>
                                <p class="text-sm my-2"> سابقه کار: </p>
                                <p class="text-sm my-2">  شماره نظام پزشکی: </p>
                            </div>
                        </div>
                        <hr>
                        <div class="mt-4">
                            <p class="text-base"> خدمات: </p>
                        </div>
                        <div class="md:flex mt-2 mb-8">
                            <p class="text-sm flex p-2"> <img src="../../../../assets/img/icon/video-call.svg" alt=""  width="20px"> <span> مشاوره تصویری </span></p>
                            <p class="text-sm flex p-2"> <img src="../../../../assets/img/icon/voice-call.svg" alt="" width="16px"> مشاوره تلفنی </p>
                            <p class="text-sm flex p-2"> <img src="../../../../assets/img/icon/message.svg" alt="" width="22px"> مشاوره متنی </p>
                        </div>
                    </div>

                    <div class="bg-white rounded p-4 mb-6 shadow-lg">
                        <div class="relative flex break-words">
                            ### CALENDAR ###
                        </div>
                    </div>

                    <div class="bg-white rounded mb-6 shadow-lg">
                        <div class="relative flex break-words bg-primary-light p-3">
                            <h5 class="font-bold text-primary"> درباره پزشک  </h5>
                                
                        </div>
                        <div class="p-3">
                            <p class="text-base">  </p>
                            <br><br>
                        </div>
                    </div>

                    <div class="bg-white rounded mb-6 shadow-lg">
                        <div class="relative flex break-words bg-primary-light p-3">
                            <h5 class="font-bold text-primary">  اطلاعات مطب  </h5>
                                
                        </div>
                        <div class="p-3">
                            <p class="text-base">  </p>
                            <br><br>
                        </div>
                    </div>

                    <div class="bg-white rounded mb-6 shadow-lg">
                        <div class="relative flex break-words bg-primary-light p-3">
                            <h5 class="font-bold text-primary">  نظرسنجی و امتیاز دهی  </h5>
                                
                        </div>
                        <div class="p-3">
                            <p class="text-base">  </p>
                            <br><br><br><br>
                        </div>
                    </div>

                </div>
                <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
                    <div class="bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
                        <ul class="w-full">
                            <li class="w-full my-2">
                                <input type="radio" id="hosting-video" name="hosting" value="" class="visit-type text-primary" />
                                <label for="hosting-video" class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100">                           
                                    <div class="inline-flex items-center justify-between ">
                                        <div class="flex text-lg font-semibold">  <img src="../../../../assets/img/icon/video-call.svg" alt="" class="ml-2"  width="20px"> <span> مشاوره تصویری </span> </div>
                                        
                                        <span class="bg-gray-200 py-1 px-2 rounded-lg text-sm"> 150,000 تومان </span>
                                    </div>
                                    <div class="block">
                                        <div class="w-full mt-3 pr-6"> ۲۰ دقیقه مکالمه تصویری + چت با پزشک </div>
                                    </div>
                                </label>
                            </li>
                            <li class="w-full my-2">
                                <input type="radio" id="hosting-call" name="hosting" value="" class="visit-type text-primary" />
                                <label for="hosting-call" class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100">                           
                                    <div class="inline-flex items-center justify-between ">
                                        <div class="flex text-lg font-semibold">  <img src="../../../../assets/img/icon/voice-call.svg" alt="" class="ml-2"  width="16px"> <span> مشاوره تلفنی </span> </div>
                                        
                                        <span class="bg-gray-200 py-1 px-2 rounded-lg text-sm"> 150,000 تومان </span>
                                    </div>
                                    <div class="block">
                                        <div class="w-full mt-3 pr-6"> ۲۰ دقیقه مکالمه تصویری + چت با پزشک </div>
                                    </div>
                                </label>
                            </li>
                            <li class="w-full my-2">
                                <input type="radio" id="hosting-chat" name="hosting" value="" class="visit-type text-primary" />
                                <label for="hosting-chat" class="w-full grid p-5 text-gray-500 bg-gray-100 rounded-lg cursor-pointer peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100">                           
                                    <div class="inline-flex items-center justify-between ">
                                        <div class="flex text-lg font-semibold">  <img src="../../../../assets/img/icon/message.svg" alt="" class="ml-2"  width="20px"> <span> مشاوره متنی </span> </div>
                                        
                                        <span class="bg-gray-200 py-1 px-2 rounded-lg text-sm"> 150,000 تومان </span>
                                    </div>
                                    <div class="block">
                                        <div class="w-full mt-3 pr-6"> ۲۰ دقیقه مکالمه تصویری + چت با پزشک </div>
                                    </div>
                                </label>
                            </li>
                            
                        </ul>
                        <div class="mt-6 flex justify-end">
                            <button class="bg-primary text-white w-full rounded-lg py-3 mb-1"
                                type="button" routerLink="/visit-detail"> دریافت نوبت
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>


</main>
<app-footer></app-footer>